module.exports = __webpack_public_path__ + "img/logo_res.7895c1a2.png";